import Navbar from "@/New_Update/Navbar";
import Hero from "@/New_Update/Hero";
import About from "@/New_Update/About";
import Skills from "@/New_Update/Skills";
import Projects from "@/New_Update/Projects";
import Contact from "@/New_Update/Contact";
import Footer from "@/New_Update/Footer";
import SectionReveal from "@/components/SectionReveal";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <Hero />
        <SectionReveal direction="left">
          <About />
        </SectionReveal>
        <SectionReveal direction="right">
          <Skills />
        </SectionReveal>
        <SectionReveal direction="left">
          <Projects />
        </SectionReveal>

        <SectionReveal direction="right">
          <Contact />
        </SectionReveal>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
